import { render, staticRenderFns } from "./installers.vue?vue&type=template&id=6fb9a9d8&"
import script from "./installers.vue?vue&type=script&lang=js&"
export * from "./installers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports